<template>
  <div class="page-container">
    <el-card class="card">
      <template #header>
        <div class="card-header">
          <span>IoT Server API 文档</span>
        </div>
      </template>
      <div class="doc-content markdown-body" v-html="html"></div>
    </el-card>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import MarkdownIt from 'markdown-it';
// 通过相对路径直接导入仓库根目录下的 docs/IOT_SERVER_API.md
// 当前文件位于 main/manager_web/src/views，因此回到项目根需要 ../../../../
import docContent from '../../../../docs/IOT_SERVER_API.md';

const md = new MarkdownIt({
  html: false,    // 不允许原始 HTML，避免 XSS
  linkify: true,  // 自动识别链接
  breaks: true,   // 将换行视为 <br>
});

const html = computed(() => md.render(docContent));
</script>

<style scoped>
.page-container {
  padding: 20px;
}

.card {
  max-width: 1200px;
  margin: 0 auto;
}

.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  font-weight: 500;
}

.doc-content {
  font-size: 14px;
  line-height: 1.7;
  color: #303133;
}

.markdown-body h1,
.markdown-body h2,
.markdown-body h3 {
  font-weight: 600;
  margin: 16px 0 8px;
}

.markdown-body h1 {
  font-size: 24px;
}

.markdown-body h2 {
  font-size: 20px;
}

.markdown-body h3 {
  font-size: 16px;
}

.markdown-body p {
  margin: 8px 0;
}

.markdown-body ul,
.markdown-body ol {
  padding-left: 24px;
  margin: 8px 0;
}

.markdown-body code {
  font-family: Menlo, Monaco, Consolas, 'Courier New', monospace;
  background-color: #f5f5f5;
  padding: 2px 4px;
  border-radius: 3px;
  font-size: 13px;
}

.markdown-body pre {
  background-color: #f5f5f5;
  padding: 12px;
  border-radius: 4px;
  overflow-x: auto;
  font-size: 13px;
}

.markdown-body table {
  border-collapse: collapse;
  width: 100%;
  margin: 12px 0;
}

.markdown-body table th,
.markdown-body table td {
  border: 1px solid #e4e7ed;
  padding: 6px 8px;
}

.markdown-body table th {
  background-color: #f5f7fa;
  font-weight: 600;
}
</style>

